import { FC, useCallback, useState } from 'react';
import { ProviderField } from '../../../../../../../models/provider';
import { SubmitProviderInputsPayload } from '../../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import {
  ApplicationEvent,
  PageView,
  UserInteractionEvent,
} from '../../../../../../../models/analytics';
import { usePageViewEvents } from '../../../../../../../core/Analytics/usePageViewEvents';
import { MultipleFieldsView } from './MultipleFieldsView';

type Props = {
  fields: ProviderField[];
  onSubmit: (values: SubmitProviderInputsPayload) => void;
};

export const MultipleFieldsSupplementalScreen: FC<Props> = ({ fields, onSubmit }) => {
  const { sendViewInteractionEvent, analytics } = usePageViewEvents({
    pageView: PageView.MULTIPLE_FIELDS_TEMPLATE_SCREEN,
  });

  const handleSubmitWithAnalytics = useCallback(
    (values: SubmitProviderInputsPayload) => {
      sendViewInteractionEvent({
        interaction: UserInteractionEvent.SUBMIT_SUPPLEMENTAL_INFORMATION,
      });
      onSubmit(values);
    },
    [onSubmit, sendViewInteractionEvent]
  );

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handleSetIsButtonDisabled = (value: boolean) => {
    if (value) {
      analytics.sendApplicationEventOnce(ApplicationEvent.MULTIPLE_FIELDS_SUBMIT_BUTTON_ENABLED);
    }

    analytics.sendApplicationEventOnce(ApplicationEvent.MULTIPLE_FIELDS_SUBMIT_BUTTON_DISABLED);
    setIsButtonDisabled(value);
  };

  return (
    <MultipleFieldsView
      fields={fields}
      isButtonDisabled={isButtonDisabled}
      setIsButtonDisabled={handleSetIsButtonDisabled}
      onSubmit={handleSubmitWithAnalytics}
    />
  );
};
